import _ from 'lodash';
import React, { useEffect } from 'react';
import NavPills from 'components/NavPills/NavPills';
import Button from '../../../components/CustomButtons/Button';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import Close from '@material-ui/icons/Close';
import SystemStatusIcon from '@material-ui/icons/InfoOutlined';
import WiseneCardIcon from '../WiseneCardIcon/WiseneCardIcon';
import Loading from '../Loading/Loading';
import NodeStatusFooter from '../NodeStatusFooter/NodeStatusFooter.jsx';
import { Line } from 'react-chartjs-2';
import zoomPlugin from 'chartjs-plugin-zoom';
import "chartjs-adapter-date-fns";
import './NodeGraphCard.css';
import { headerStyleNoMeasurements, loaderStyleEmptyCard } from '../../helpers/CustomStyles';
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import { withRouter } from 'react-router-dom';
import date from "date-and-time";
import { format, startOfWeek, getDay, addDays } from 'date-fns';
import 'chartjs-adapter-date-fns';

class NodeGraphCard extends React.Component {
    deflectionChartRef = React.createRef();
    temperatureChartRef = React.createRef();
    activeTab = this.props.activeTab;
    showPoints = false;

	componentDidMount() {
		this.closeWarning();
	}
	componentDidUpdate() {
		this.resetZoom();
	}

	componentDidCatch(error, errorInfo) {
		console.error('ERROR__', error, errorInfo);
	}

    resetZoom = () => {
        const chartInstance = this.deflectionChartRef?.current ?? this.temperatureChartRef.current;
        if (chartInstance) {
            chartInstance.resetZoom();
        }
    }

    toggleDataPointsVisibility = () => {
        const chartInstance = this.deflectionChartRef?.current || this.temperatureChartRef?.current;
        const button = document.querySelector('.togglePoints');
        if (chartInstance) {
            const datasets = chartInstance.data.datasets;
            datasets[datasets.length-1].hidden = !datasets[datasets.length-1].hidden;
            chartInstance.data.datasets[0].hidden = !chartInstance.data.datasets[0].hidden;
            chartInstance.update();
            button.textContent = button.textContent === 'show points' ? 'show average' : 'show points';
            this.showPoints = button.textContent === 'show average';
        } else {
            button.textContent = button.textContent === 'show points' ? 'show average' : 'show points';
            this.showPoints = button.textContent === 'show average';
            this.forceUpdate();
        }
    }

	closeWarning = () => {
		const { noMeasurementsWarnings, closeNoMeasurementsWarning } = this.props;
		if (noMeasurementsWarnings.length > 0) {
			noMeasurementsWarnings.forEach((warningId) => {
				closeNoMeasurementsWarning(warningId);
			});
		}
	};
    handleTabChange = (newTabValue) => {
        const { history, location } = this.props;
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('tab', newTabValue);
        history.push(`${location.pathname}?${searchParams.toString()}`);
        this.activeTab = newTabValue;
    }

    addIntervalToDateString = (dateString, interval) => {
        const oldDate = new Date(dateString);
        let newDate;
        if (Math.abs(interval) === 7) {
            newDate = date.addDays(oldDate, interval);
        } else {
            newDate = date.addMonths(oldDate, interval/30);
        }
        return newDate.toISOString();
    }

    handleDateRangeChange = (newRange, arrowButton) => {
        const { history, location, getMeasurements, node } = this.props;
        const searchParams = new URLSearchParams(location.search);
        const currentRange = parseInt(searchParams.get('days'));
        const currentMeasurementsEndDate = searchParams.get('to');
        const currentMeasurementsStartDate = searchParams.get('from');

        let start, end;
        if (arrowButton === null) {
            searchParams.set('days', newRange);
            searchParams.set('from', this.addIntervalToDateString(currentMeasurementsEndDate, -newRange));
        } else {
            if (arrowButton === "next") {
                searchParams.set('to', this.addIntervalToDateString(currentMeasurementsEndDate, currentRange));
                searchParams.set('from', this.addIntervalToDateString(currentMeasurementsStartDate, currentRange));
            } else {
                searchParams.set('to', this.addIntervalToDateString(currentMeasurementsEndDate, -currentRange));
                searchParams.set('from', this.addIntervalToDateString(currentMeasurementsStartDate, -currentRange));
            }
        }
        start = searchParams.get('from');
        end = searchParams.get('to');
        getMeasurements({NodeID: node.id, Start: start, End: end});
        history.push(`${location.pathname}?${searchParams.toString()}`);

    }

	renderMobileNotifications = () => {
		const { noMeasurementsWarnings, mobileView, closeNoMeasurementsWarning } = this.props;

		if (mobileView && noMeasurementsWarnings.length > 0) {
			const result = noMeasurementsWarnings.map((currentWarningId, i) => {
				this.warningTimeout = setTimeout(() => {
					closeNoMeasurementsWarning(currentWarningId);
				}, 60000);
				return (
					<h5 className={'no-measurements-warning-graph show-no-measurements-animation-graph'} style={headerStyleNoMeasurements}>
						No measurements in this range
						<Button
							simple
							justIcon
							style={{ width: '24px', height: '24px', padding: '0' }}
							onClick={() => closeNoMeasurementsWarning(currentWarningId)}
							data-testid='closeNoMeasurementsWarningGraph'
						>
							<Close style={{ width: '20px', height: '20px', padding: '0', transform: 'translateX(15px)' }} />
						</Button>
					</h5>
				);
			});
			return result;
		}
	};

    renderNoMeasurementsForRange = () => {
        const {location, mobileView} = this.props;
        const searchParams = new URLSearchParams(location.search);
        const startISOString = searchParams.get('from');
        const endISOString = searchParams.get('to');
        const startDate = new Date(startISOString);
        const endDate = new Date(endISOString);
        const startString = date.format(startDate, 'DD/MM/YYYY HH:mm:ss');
        const endString = date.format(endDate, 'DD/MM/YYYY HH:mm:ss');
        return (
            <h3 alignCenter={true} style={{ display: 'flex', justifyContent: 'center', minHeight: mobileView ? '250px' : '600px', fontSize: mobileView ? '14px' : '18px' }}>
                No data for selected period <br/>
                ({startString} - {endString})
            </h3>
        );
    };


	render() {
		const {
			color,
			measurementsLoading,
			node,
			classes,
			mobileView,
		} = this.props;
		const { cardCategory, cardTitle } = this.props.classes;
		const measurements = this.props.measurements ?? [];
        const deviceRole = node.DeviceRole;
        let measurementPoints = {
            x: [],
            y: []
        };

		let L1ThreatLevel :number[] = [];
		let L2ThreatLevel :number[] = [];
		let L3ThreatLevel :number[] = [];
		let L4ThreatLevel :number[] = [];

		let L1ThreatLevelNegative :number[] = [];
		let L2ThreatLevelNegative :number[] = [];
		let L3ThreatLevelNegative :number[] = [];
		let L4ThreatLevelNegative :number[] = [];

		let simpleMovingAverage = {
			x: [],
			y: []
		};

		let temperatures = {
			x: [],
			y: []
		};
        let colorData = [];
		let drawNegativeThresholds = false;
		let drawPositiveThresholds = false;
        let deflectionMeasurements = [];
        let minDeflection;
        let maxDeflection;
        let maxThreatLvlValue;
        let allDeflectionNull = true;
        const modulo = Math.floor(measurements.length/300) + 1;

        for (let i = 0; i < measurements.length; i++)
		{
            const el = measurements[i];
			//fill in x and y axes:
			measurementPoints.y.push(el.CalculatedDeflection);
			const localTime = new Date(el.MeasurementTimestamp);
			measurementPoints.x.push(localTime);
			deflectionMeasurements.push({x: localTime, y: el.CalculatedDeflection});
            if (allDeflectionNull && el.CalculatedDeflection !== null) {
                allDeflectionNull = false;
            }

			//capture flag if negative/positive thresholds should be drawing:
			if (el.CalculatedDeflection < 0) {
				drawNegativeThresholds = true;
			}
			if (el.CalculatedDeflection > 0) {
				drawPositiveThresholds = true;
			}

            //get min/max deflection values to calculate y axis range on deflection chart
            if (minDeflection === undefined || el.CalculatedDeflection < minDeflection) {
                minDeflection = el.CalculatedDeflection;
            }
            if (maxDeflection === undefined || el.CalculatedDeflection > maxDeflection) {
                maxDeflection = el.CalculatedDeflection;
            }

			//calculate L1, L2, L3, L4 Thresholds or sign null if permissible value doesn't exist:
			const L1Value = !el.ThresholdLevel1 || !el.PermissibleValue ? null : (el.PermissibleValue  * el.ThresholdLevel1) / 100;
			const L2Value = !el.ThresholdLevel2 || !el.PermissibleValue ? null : (el.PermissibleValue  * el.ThresholdLevel2) / 100;
			const L3Value = !el.ThresholdLevel3 || !el.PermissibleValue ? null : (el.PermissibleValue  * el.ThresholdLevel3) / 100;
			const L4Value = !el.ThresholdLevel4 || !el.PermissibleValue ? null : (el.PermissibleValue  * el.ThresholdLevel4) / 100;

            //fill in thresholds for positive values:
            // only show some points if the list is long
            let showThreatLevels = i == 0 || i == measurements.length - 1 || i % modulo == 0 || measurements.length < 300;
            if (!showThreatLevels && i > 0) {
                // show when levels change
                const old = measurements[i-1];
                if (old.ThresholdLevel1 != el.ThresholdLevel1
                    || old.ThresholdLevel2 != el.ThresholdLevel2
                    || old.ThresholdLevel3 != el.ThresholdLevel3
                    || old.ThresholdLevel4 != el.ThresholdLevel4
                    || old.PermissibleValue != el.PermissibleValue)
                showThreatLevels = true;
            }

            if (L1Value !== null) {
                L1ThreatLevel.push(showThreatLevels ? L1Value : null);
                L1ThreatLevelNegative.push(showThreatLevels ? -L1Value : null);
            }
            if (L2Value !== null) {
                L2ThreatLevel.push(showThreatLevels ? L2Value : null);
                L2ThreatLevelNegative.push(showThreatLevels ? -L2Value : null);
            }
            if (L3Value !== null) {
                L3ThreatLevel.push(showThreatLevels ? L3Value : null);
                L3ThreatLevelNegative.push(showThreatLevels ? -L3Value : null);
            }
            if (L4Value !== null) {
                L4ThreatLevel.push(showThreatLevels ? L4Value : null);
                L4ThreatLevelNegative.push(showThreatLevels ? -L4Value : null);
            }
            if (maxThreatLvlValue === undefined || _.max([L1Value, L2Value, L3Value, L4Value]) > maxThreatLvlValue) {
                maxThreatLvlValue = _.max([L1Value, L2Value, L3Value, L4Value]);
            }

            //if point is obstructed:
            colorData[i] = 'black';
            if (el.ObstructionStatus !== 0 && el.ObstructionStatus !== null) {
                colorData[i] = '#f058d4';
            }

			//fill in temperature x axis:
			temperatures.x.push(localTime);
			//fill in temperatures y axis
			temperatures.y.push(el.Temperature1);
		}
        if (!drawNegativeThresholds && !drawPositiveThresholds) {
            drawPositiveThresholds = true;
        }

		//calculate averaged data for deflection chart:
		let numberOfLastPeriods = 7;
		let averagedData = [];
		let lastValidVal = 0;
		for (let i = 0; i < measurements.length; i++) {
			averagedData[i] = 0;
			let j = 0;
			for (; j < numberOfLastPeriods && (i + j < measurements.length); j++) {
			    let curVal = parseFloat(measurementPoints.y[i + j]);
			    if (!isNaN(curVal)) {
			        lastValidVal = curVal;
			    }
				averagedData[i] += lastValidVal;
			}
			averagedData[i] /= j;
		}

		const isInclinometer = node.MainSensorType === 'inclinometer';

		//filling in averaged data for deflection chart:
        if (!allDeflectionNull) {
            const fractionDigits = isInclinometer ? 3 : 1;
            for (let i = 0; i < measurements.length; i++) {
                    simpleMovingAverage.y.push(averagedData[i]?.toFixed(fractionDigits));
            }
        } else {
            simpleMovingAverage.y = measurementPoints.y;
        }


        const offset = isInclinometer ? 0.05 : 5;
		const minY = drawNegativeThresholds ? _.min([minDeflection, -maxThreatLvlValue]) - offset : 0;
		const maxY = drawPositiveThresholds ? _.max([maxDeflection, maxThreatLvlValue]) + offset : 0;
        const searchParams = new URLSearchParams(this.props.location.search);
        const measurementsRange = searchParams.get('days');

        const temperatureChartOptions = {
            responsive: true,
            animation: false,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        title: function (context) {
                            return context[0]?.parsed.x ? (new Date(context[0].parsed.x)).toLocaleString('en-US', {
                                  year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false}) : '';
                        },
                        label: function(context) {
                            const unit = '°C';
                            const value = context.parsed.y === null || context.parsed.y === undefined ? '' : context.parsed.y;
                            return `${value}${unit}`;
                        }
                    }
                },
                zoom: {
                    zoom: {
                        wheel: {
                            enabled: false,
                        },
                        pinch: {
                            enabled: mobileView,
                        },
                        mode: 'xy'
                    },
                    pan: {
                        enabled: true,
                        mode: 'xy',
                    },
                    limits: {
                      x: {min: 'original', max: 'original', minRange: 10*6*10*60*1000},
                      y: {min: 'original', max: 'original', minRange: 1},
                    },
                }
            },
            scales: {
                x: {
                    type: 'time',
                    clip: false,
                    time: {
                        unit: measurementsRange == '7' ? 'hour' : 'day',
                        displayFormats: {
                            day: 'yyyy-MM-dd',
                            hour: 'yyyy-MM-dd HH:mm'
                        }
                    },
                    reverse: false,
                    ticks: {
                        font: {
                            size: mobileView ? 8 : 12,
                        },
                        includeBounds: false,
                        maxTicksLimit: mobileView ? 16 : 60,
                        maxRotation: 0,
                        // source: 'auto',
                        callback: function(value, index, ticks) {
                            const date = new Date(value);

                            if (measurementsRange === '90') {
                                const startDate = new Date(ticks[0].value);
                                const startDay = getDay(startDate);
                                const offset = (7 - startDay + 1) % 7;
                                const adjustedDate = addDays(startDate, offset);
                                const diffInDays = Math.floor((date - adjustedDate) / (1000 * 60 * 60 * 24));
                            
                                if (diffInDays % 14 === 0) {
                                    // tick and label
                                    return format(date, 'dd-MM-yyyy');
                                } else if (diffInDays % 7 === 0) {
                                    //just grid line (tick with hidden label)
                                    return '';
                                }
                            } else if (measurementsRange === '30') { 
                                if (getDay(date) === 1) {
                                    return format(date, 'dd-MM-yyyy');
                                } 
                                return '';
                            } else if (measurementsRange === '7') { 
                                if (date.getHours() === 0 && date.getMinutes() === 0) {
                                    return format(date, 'dd-MM-yyyy');
                                } else if (date.getHours()%6 == 0 && date.getMinutes() === 0) {
                                    return '';
                                }
                            }
                            // not tick, no label
                            return null;
                        }
                    }
                },
                y: {
                    reverse: false,
                    max: 60,
                    min: -20,
                    ticks: {
                        font: {
                            size: mobileView ? 10 : 12,
                        },
                        includeBounds: false,

                    }
                },
            },
            onClick: (e) => {
              const chart = e.chart;
              chart.options.plugins.zoom.zoom.wheel.enabled = !chart.options.plugins.zoom.zoom.wheel.enabled;
              chart.update();
            }
        };

        const deflectionChartOptions = {
            responsive: true,
            animation: false,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        title: function (context) {
                          const label = context[0]?.dataset?.label;
                            if (label === 'measurement') {
                                return context[0]?.raw?.x ? (new Date(context[0].raw.x)).toLocaleString('en-US', {
                                  year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false}) : '';
                            }
                          return '';
                        },
                        label: function(context) {
                            const label = context.dataset.label;
                            if (label === 'measurement') {
                                const unit = isInclinometer ? '°' : 'mm';
                                const value = context.parsed.y === null || context.parsed.y === undefined ? '' : context.parsed.y;
                                return `${value}${unit}`;
                            }
                            return label;
                        }
                    }
                },
                zoom: {
                    zoom: {
                        wheel: {
                            enabled: false,
                        },
                        pinch: {
                            enabled: mobileView,
                        },
                        mode: 'xy'
                    },
                    pan: {
                        enabled: true,
                        mode: 'xy',
                    },
                    limits: {
                      x: {min: 'original', max: 'original', minRange: 10*6*10*60*1000},
                      y: {min: 'original', max: 'original', minRange: isInclinometer ? 0.06 : 6},
                    },
                }
            },
            scales: {
                x: {
                    type: 'time',
                    clip: false,
                    time: {
                        unit: measurementsRange == '7' ? 'hour' : 'day',
                        displayFormats: {
                            day: 'yyyy-MM-dd',
                            hour: 'yyyy-MM-dd HH:mm'
                        }
                    },
                    reverse: false,
                    ticks: {
                        font: {
                            size: mobileView ? 8 : 12,
                        },
                        maxTicksLimit: mobileView ? 16 : 60,
                        maxRotation: 0,
                        callback: function(value, index, ticks) {
                            const date = new Date(value);

                            if (measurementsRange === '90') {
                                const startDate = new Date(ticks[0].value);
                                const startDay = getDay(startDate);
                                const offset = (7 - startDay + 1) % 7;
                                const adjustedDate = addDays(startDate, offset);
                                const diffInDays = Math.floor((date - adjustedDate) / (1000 * 60 * 60 * 24));
                            
                                if (diffInDays % 14 === 0) {
                                    // tick and label
                                    return format(date, 'dd-MM-yyyy');
                                } else if (diffInDays % 7 === 0) {
                                    //just grid line (tick with hidden label)
                                    return '';
                                }
                            } else if (measurementsRange === '30') { 
                                if (getDay(date) === 1) {
                                    return format(date, 'dd-MM-yyyy');
                                } 
                                return '';
                            } else if (measurementsRange === '7') { 
                                if (date.getHours() === 0 && date.getMinutes() === 0) {
                                    return format(date, 'dd-MM-yyyy');
                                } else if (date.getHours()%6 == 0 && date.getMinutes() === 0) {
                                    return '';
                                }
                            }
                            // not tick, no label
                            return null;
                        }
                    },
                    grid: {
                        display: true,
                        drawOnChartArea: true,
                    },
                },
                y: {
                    reverse: false,
                    max: maxY,
                    min: minY,
                    ticks: {
                        font: {
                            size: mobileView ? 10 : 12,
                        },
                        includeBounds: false,

                    }
                },
            },
            onClick: (e) => {
              const chart = e.chart;
              chart.options.plugins.zoom.zoom.wheel.enabled = !chart.options.plugins.zoom.zoom.wheel.enabled;
              chart.update();
            }
        };

        const L1Data = drawPositiveThresholds && L1ThreatLevel.length ? [L1ThreatLevel[0], ...L1ThreatLevel, L1ThreatLevel[L1ThreatLevel.length-1]] : [];
        const L2Data = drawPositiveThresholds && L2ThreatLevel.length ? [L2ThreatLevel[0], ...L2ThreatLevel, L2ThreatLevel[L2ThreatLevel.length-1]] : [];
        const L3Data = drawPositiveThresholds && L3ThreatLevel.length ? [L3ThreatLevel[0], ...L3ThreatLevel, L3ThreatLevel[L3ThreatLevel.length-1]] : [];
        const L4Data = drawPositiveThresholds && L4ThreatLevel.length ? [L4ThreatLevel[0], ...L4ThreatLevel, L4ThreatLevel[L4ThreatLevel.length-1]] : [];
        const L1NegData = drawNegativeThresholds && L1ThreatLevel.length ? [L1ThreatLevelNegative[0], ...L1ThreatLevelNegative, L1ThreatLevelNegative[L1ThreatLevelNegative.length-1]] : [];
        const L2NegData = drawNegativeThresholds && L2ThreatLevel.length ? [L2ThreatLevelNegative[0], ...L2ThreatLevelNegative, L2ThreatLevelNegative[L2ThreatLevelNegative.length-1]] : [];
        const L3NegData = drawNegativeThresholds && L3ThreatLevel.length ? [L3ThreatLevelNegative[0], ...L3ThreatLevelNegative, L3ThreatLevelNegative[L3ThreatLevelNegative.length-1]] : [];
        const L4NegData = drawNegativeThresholds && L4ThreatLevel.length ? [L4ThreatLevelNegative[0], ...L4ThreatLevelNegative, L4ThreatLevelNegative[L4ThreatLevelNegative.length-1]] : [];
        const threatLevels = [L1Data, L2Data, L3Data, L4Data, L1NegData, L2NegData, L3NegData, L4NegData];
        let backgroundData = [];
        for (const level of threatLevels) {
            if (level.length > 0) {
                backgroundData = level;
                break;
            }
        }

        const deflOffsetBefore = measurements.length ? new Date(measurementPoints.x[0].getTime() + 60*60*1000) : null;
        const deflOffsetAfter = measurements.length ?  new Date(measurementPoints.x[measurementPoints.x.length-1].getTime() - 60*60*1000) : null;
        const deflLabels = [deflOffsetBefore, ...measurementPoints.x, deflOffsetAfter];

        const tempOffsetBefore = temperatures.x.length ? new Date(temperatures.x[0].getTime() + 60*60*1000) : null;
        const tempOoffsetAfter = temperatures.x.length ?  new Date(temperatures.x[temperatures.x.length-1].getTime() - 60*60*1000) : null;
        const tempLabels = [tempOffsetBefore, ...temperatures.x, tempOoffsetAfter];

        const temperatureChartData = {
            labels: tempLabels,
            datasets: [
                {
                    label: 'temperature2',
                    data: [null, ...temperatures.y, null],
                    hidden: !this.showPoints,
                    showLine: false,
                    pointRadius: 3,
                    hitRadius: 20,
                    backgroundColor: 'black'
                },
                {
                    label: 'temperature',
                    data: [null, ...temperatures.y, null],
                    hidden: this.showPoints,
                    pointRadius: 0,
                    hitRadius: 20,
                    borderWidth: 2,
                    borderColor: 'black',
                    backgroundColor: 'black',
                    spanGaps: false
                }
            ]
        };

        const deflectionChartData = {
            labels: deflLabels,
            datasets: [
                {
                    label: 'measurement',
                    data: deflectionMeasurements,
                    hidden: !this.showPoints,
                    showLine: false,
                    pointRadius: 3,
                    hitRadius: 20,
                    backgroundColor: colorData,
                    order: 0
                },
                {
                    label: 'L4',
                    pointRadius: 0,
                    data: L4Data,
                    hidden: !L4Data.length,
                    backgroundColor: 'rgba(255, 0, 0, 0.4)',
                    hitRadius: 10,
                    spanGaps: true,
                    fill: 'end',
                    order: 1
                },
                {
                    label: 'L3',
                    pointRadius: 0,
                    data: L3Data,
                    hidden: !L3Data.length,
                    backgroundColor: 'rgba(255, 153, 0, 0.4)',
                    hitRadius: 10,
                    spanGaps: true,
                    fill: '-1',
                    order: 1
                },
                {
                    label: 'L2',
                    pointRadius: 0,
                    data: L2Data,
                    hidden: !L2Data.length,
                    backgroundColor: 'rgba(255, 225, 28, 0.4)',
                    hitRadius: 10,
                    spanGaps: true,
                    fill: '-1',
                    order: 1
                },

                {
                    label: 'L1',
                    pointRadius: 0,
                    data: L1Data,
                    hidden: !L1Data.length,
                    backgroundColor: 'rgba(125, 242, 0, 0.4)',
                    hitRadius: 10,
                    spanGaps: true,
                    fill: '-1',
                    order: 1
                },
                {
                    //background
                    data: backgroundData,
                    pointRadius: 0,
                    backgroundColor: 'rgba(49, 184, 0, 0.4)',
                    fill:  drawNegativeThresholds && drawPositiveThresholds ? '+1' : (drawPositiveThresholds ? 'start' : 'end'),
                    spanGaps: true,
                    order: 1
                },
                {
                    label: '-L1',
                    pointRadius: 0,
                    data: L1NegData,
                    hidden: !L1NegData.length,
                    backgroundColor: 'rgba(125, 242, 0, 0.4)',
                    hitRadius: 10,
                    spanGaps: true,
                    fill: '+1',
                    order: 1
                },
                {
                    label: '-L2',
                    pointRadius: 0,
                    data: L2NegData,
                    hidden: !L2NegData.length,
                    backgroundColor: 'rgba(255, 225, 28, 0.4)',
                    hitRadius: 10,
                    spanGaps: true,
                    fill: '+1',
                    order: 1
                },
                {
                    label: '-L3',
                    pointRadius: 0,
                    data: L3NegData,
                    hidden: !L3NegData.length,
                    backgroundColor: 'rgba(255, 153, 0, 0.4)',
                    hitRadius: 10,
                    spanGaps: true,
                    fill: '+1',
                    order: 1
                },
                {
                    label: '-L4',
                    pointRadius: 0,
                    data: L4NegData,
                    hidden: !L4NegData.length,
                    backgroundColor: 'rgba(255, 0, 0, 0.4)',
                    hitRadius: 10,
                    spanGaps: true,
                    fill: 'start',
                    order: 1
                },
                {
                    label: 'average',
                    showLine: true,
                    borderWidth: 2,
                    pointRadius: 0,
                    hitRadius: 0,
                    data: [null, ...simpleMovingAverage.y, null],
                    hidden: this.showPoints,
                    borderColor: 'black',
                    spanGaps: false,
                    order: 0
                },
            ]
        };
        const zoomOutButton = (
            <Button
                className='deflectionButton'
                color={'info'}
                onClick={this.resetZoom}
                size={'sm'}
                style={{borderRadius: '20px', fontWeight: '500'}}
                disabled={this.props.measurementsLoading}
            >
                Zoom out
            </Button>
        );

		const temperatureTabContent = (
            <>
            { this.props.measurementsLoading ?
                <div className={'deflection-chart-container'}
                     style={{position: "relative", margin: "auto", width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <Loading transform={0.85} width={70} height={this.props.mobileView ? 300 : 600} color='gray'/>
                </div> :
                <div className={'deflection-chart-container'} style={{position: "relative", margin: "auto", width: "100%" }}>
                    <Line
                        className='deflectionChart temperatureChart'
                        options={temperatureChartOptions}
                        data={temperatureChartData}
                        plugins={[zoomPlugin]}
                        ref={this.temperatureChartRef}
                    />
                </div>
            }
            <div style={{justifyContent: 'center', display: 'flex'}}>
                {zoomOutButton}
                <Button
                    className='deflectionButton togglePoints'
                    color={'info'}
                    onClick={this.toggleDataPointsVisibility}
                    size={'sm'}
                    style={{borderRadius: '20px', fontWeight: '500'}}
                    disabled={this.props.measurementsLoading}
                >
                   {this.showPoints ? 'show average' : 'show points'}
                </Button>
            </div>
            </>
        );

        const deflectionTabContent = (
            <>
            {this.props.measurementsLoading ?
                <div className={'deflection-chart-container'}
                     style={{position: "relative", margin: "auto", width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <Loading transform={0.85} width={70} height={this.props.mobileView ? 300 : 600} color='gray'/>
                </div> :
                <div className={'deflection-chart-container'}
                     style={{position: "relative", margin: "auto", width: "100%"}}>
                    <Line
                        className='deflectionChart'
                        options={deflectionChartOptions}
                        data={deflectionChartData}
                        plugins={[zoomPlugin]}
                        ref={this.deflectionChartRef}
                    />
                </div>
            }
                <div style={{justifyContent: 'center', display: 'flex'}}>
                    {zoomOutButton}
                    <Button
                        className='deflectionButton togglePoints'
                    color={'info'}
                    onClick={this.toggleDataPointsVisibility}
                    size={'sm'}
                    style={{borderRadius: '20px', fontWeight: '500'}}
                    disabled={this.props.measurementsLoading}
                >
                   {this.showPoints ? 'show average' : 'show points'}
                </Button>
            </div>
            </>
        );

        const rangeButtons = () => {
            const searchParams = new URLSearchParams(this.props.location.search);
            const measurementsRange = searchParams.get('days');
            const { measurementsLoading } = this.props;
            return (
                <div style ={{justifyContent: 'center', display: 'flex'}}>
                    <Button
                        className='deflectionButton deflectionButtonFetch'
                        color={'info'}
                        onClick={() => {this.handleDateRangeChange(null, "prev")}}
                        size={'sm'}
                        style={{borderRadius: '50px', fontWeight: '400'}}
                        disabled={measurementsLoading}
                    >
                       <KeyboardArrowLeft/>
                    </Button>
                    <Button
                        className='deflectionButton deflectionButtonRange'
                        color={'info'}
                        disabled={measurementsRange === '7' || measurementsLoading}
                        onClick={() => {this.handleDateRangeChange(7, null)}}
                        size={'sm'}
                        style={{borderRadius: '50px', fontWeight: '400'}}
                    >
                       1 week
                    </Button>
                    <Button
                        className='deflectionButton deflectionButtonRange'
                        color={'info'}
                        disabled={measurementsRange === '30' || measurementsLoading}
                        onClick={() => {this.handleDateRangeChange(30, null)}}
                        size={'sm'}
                        style={{borderRadius: '50px', fontWeight: '400'}}
                    >
                       1 month
                    </Button>
                    <Button
                        className='deflectionButton deflectionButtonRange'
                        color={'info'}
                        disabled={measurementsRange === '90' || measurementsLoading}
                        onClick={() => {this.handleDateRangeChange(90, null)}}
                        size={'sm'}
                        style={{borderRadius: '50px', fontWeight: '400'}}
                    >
                       3 months
                    </Button>
                    <Button
                        className='deflectionButton deflectionButtonFetch'
                        color={'info'}
                        onClick={() => {this.handleDateRangeChange(null, "next")}}
                        size={'sm'}
                        style={{borderRadius: '50px', fontWeight: '400'}}
                        disabled={measurementsLoading}
                    >
                        <KeyboardArrowRight/>
                    </Button>
                </div>
            );
        };
        const deflectionTab = {tabLabel: isInclinometer? 'DISPLACEMENT [°]':'DEFLECTION [mm]', tabContent: deflectionTabContent};
        const temperatureTab = {tabLabel: 'TEMPERATURE [°C]', tabContent: temperatureTabContent};
        let tabs = [ deflectionTab, temperatureTab ];
        if (deviceRole === 'access_device' && node.MainSensorType == 'none' || deviceRole === 'retransmitter') {
            tabs = [ temperatureTab ];
        } else if (deviceRole === 'gateway') {
            tabs = [{}];
        }

        const deviceNavButtons = (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    className='deflectionButton deflectionButtonRange'
                    color={'info'}
                    onClick={() => this.props.goToDevice(this.props.prevDeviceId)}
                    size={'sm'}
                    style={{ borderRadius: '50px', fontWeight: '400', minWidth: '160px' }}
                    disabled={!this.props.prevDeviceId}
                    data-testid="previousDevice"
                >
                    <KeyboardArrowLeft /> Previous Device
                </Button>
                <Button
                    className='deflectionButton deflectionButtonRange'
                    color={'info'}
                    onClick={() => this.props.goToDevice(this.props.nextDeviceId)}
                    size={'sm'}
                    style={{ borderRadius: '50px', fontWeight: '400', minWidth: '160px' }}
                    disabled={!this.props.nextDeviceId}
                    data-testid="nextDevice"
                >
                    Next Device <KeyboardArrowRight />
                </Button>
            </div>
        );

        const cardContent = () => {
			if (deviceRole === 'gateway' || !measurements.some(el => el.Temperature1 !== null) ) {
				return this.renderNoMeasurementsForRange();
			} else {
				return (
                    <NavPills variant={'fullWidth'} color='info' alignCenter={true} tabs={tabs} activeTab={this.activeTab} handleTabChange={this.handleTabChange}/>
				);
			}
		};

		return (
			<Card>
				<CardHeader icon>
					<WiseneCardIcon color={color}>
						<SystemStatusIcon />
					</WiseneCardIcon>
					<p className={cardCategory}>System - Device</p>
					{mobileView ?
					<h4 className={cardTitle}>
						{node.SystemName} - {node.name}
					</h4>
					:
					<h3 className={cardTitle}>
						{node.SystemName} - {node.name}
				    </h3>
				    }
				</CardHeader>
				<CardBody className='node-graph-card'>
                    {deviceNavButtons}
					{cardContent()}
					{rangeButtons()}
					{this.renderMobileNotifications()}
				</CardBody>
				<NodeStatusFooter node={node} classes={classes} />
			</Card>
		);
	}
}

export default withRouter(NodeGraphCard);
